<template>
  <section v-loading="listLoading" class="page-container">
    <!--工具条-->
    <div class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.id" placeholder="编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.userId" placeholder="用户编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.status" clearable placeholder="请选择状态" @change="list">
            <el-option label="正常" value="0"></el-option>
            <el-option label="删除" value="1"></el-option>
            <el-option label="待审核" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--列表-->
    <div
      v-if="results && results.length > 0"
      class="page-section articles"
      :style="{ height: tableHeight }"
    >
      <div v-for="item in results" :key="item.id" class="article">
        <avatar :user="item.user" />
        <div class="article-right">
          <a class="article-title" :href="('/article/' + item.id) | siteUrl" target="_blank">{{
            item.title
          }}</a>
          <div class="article-meta">
            <label class="action-item info">ID: {{ item.id }}</label>
            <label v-if="item.user" class="author">{{ item.user.nickname }}</label>
            <label>{{ item.createTime | formatDate }}</label>

            <div class="article-tags">
              <el-tag v-for="tag in item.tags" :key="tag.tagId" type="info" size="mini">
                {{ tag.tagName }}
              </el-tag>
            </div>
          </div>

          <div class="article-info">
            <span v-if="item.sticky">已推荐</span>
            <span v-if="item.status === 1">已删除</span>
          </div>

          <div class="summary">{{ item.summary }}</div>
          <div class="actions">
            <el-button type="text" class="action-item" @click="showUpdateViewCountDialog(item)"
              >{{ item.viewCount }} Views</el-button
            >
            <el-button type="text" class="action-item" @click="showUpdateLikeCountDialog(item)"
              >{{ item.likeCount }} Liked</el-button
            >
            <el-button
              v-if="item.status !== 1"
              type="text"
              class="action-item"
              @click="deleteSubmit(item)"
              >删除</el-button
            >
            <el-button
              v-if="item.status === 2"
              type="text"
              class="action-item"
              @click="pendingSubmit(item)"
              >审核</el-button
            >
            <el-button
              v-if="item.sticky"
              type="text"
              class="action-item"
              @click="setSticky(item, false)"
              >取消置顶</el-button
            >
            <el-button v-else type="text" class="action-item" @click="setSticky(item, true)"
              >置顶</el-button
            >
            <el-button type="text" class="action-item" @click="push(item.id)">推送通知</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="page-section articles">
      <div class="notification is-primary">
        <strong>无数据</strong>
      </div>
    </div>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <el-dialog
      :visible.sync="updateTagsDialogVisible"
      :close-on-click-modal="false"
      title="添加标签"
    >
      <el-form label-width="80px">
        <el-form-item label="标签">
          <el-select
            v-model="updateTagForm.tags"
            style="width: 100%"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="标签"
          ></el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="updateTagsDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click.native="updateTags">提交 </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="updateViewCountDialogVisible"
      :close-on-click-modal="false"
      title="Update view count"
    >
      <el-form label-width="120px">
        <el-form-item label="view count">
          <el-input-number v-model="updateViewCountForm.viewCount" :min="1"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="updateViewCountDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="updateViewCount()">Submit</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="updateLikeCountDialogVisible"
      :close-on-click-modal="false"
      title="Update like count"
    >
      <el-form label-width="120px">
        <el-form-item label="like count">
          <el-input-number v-model="updateLikeCountForm.likeCount" :min="1"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="updateLikeCountDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="updateLikeCount()">Submit</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import Avatar from "@/components/Avatar";
export default {
  name: "News",
  components: { MyPagination, Avatar },
  data() {
    return {
      tableHeight: "700px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      tagOptions: [],
      updateTagsDialogVisible: false,
      updateViewCountDialogVisible: false,
      updateLikeCountDialogVisible: false,
      updateTagForm: {
        articleId: 0,
        tags: [],
      },
      updateViewCountForm: {
        articleId: 0,
        viewCount: 0,
      },
      updateLikeCountForm: {
        articleId: 0,
        likeCount: 0,
      },
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("base:/api/admin/article/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (err) {
        this.$message.error(err.message);
      } finally {
        this.listLoading = false;
      }
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    deleteSubmit(row) {
      const me = this;
      this.$confirm("确认要删除文章？", "提示", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.axios
            .form("base:/api/admin/article/delete", { id: row.id })
            .then((data) => {
              me.$message({ message: "删除成功", type: "success" });
              me.list();
            })
            .catch((rsp) => {
              me.$elnotify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已Cancel删除",
          });
        });
    },
    pendingSubmit(row) {
      const me = this;
      this.$confirm("确认要过审文章？", "提示", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.axios
            .form("base:/api/admin/article/pending", { id: row.id })
            .then((data) => {
              me.$message({ message: "审核成功", type: "success" });
              me.list();
            })
            .catch((rsp) => {
              me.$elnotify.error({ title: "error ", message: rsp.message });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已Cancel审核",
          });
        });
    },
    async showUpdateTags(article) {
      const tags = [];
      try {
        const tagObjs = await this.axios.get(
          "base:/api/admin/article/tags?articleId=" + article.id
        );
        if (tagObjs && tagObjs.length) {
          for (let i = 0; i < tagObjs.length; i++) {
            tags.push(tagObjs[i].tagName);
          }
        }
      } catch (e) {
        this.$message({
          type: "error",
          message: e.message || e,
        });
      }

      this.updateTagForm.articleId = article.id;
      this.updateTagForm.tags = tags;
      this.updateTagsDialogVisible = true;
    },
    async updateTags() {
      try {
        const nowTags = await this.axios.put("base:/api/admin/article/tags", {
          articleId: this.updateTagForm.articleId,
          tags: (this.updateTagForm.tags || []).join(","),
        });
        if (this.results && this.results.length) {
          for (let i = 0; i < this.results.length; i++) {
            if (this.results[i].id === this.updateTagForm.articleId) {
              this.results[i].tags = nowTags;
            }
          }
        }
        this.updateTagsDialogVisible = false;
      } catch (e) {
        this.$message({
          type: "error",
          message: e.message || e,
        });
      }
    },
    async setSticky(article, sticky) {
      try {
        await this.axios.form("base:/api/admin/article/sticky", {
          id: article.id,
          sticky,
        });
        article.sticky = sticky;
        this.$message.success("success");
      } catch (e) {
        this.$message({
          type: "error",
          message: e.message || e,
        });
      }
    },
    showUpdateViewCountDialog(item) {
      this.updateViewCountDialogVisible = true;
      this.updateViewCountForm.articleId = item.id;
      this.updateViewCountForm.viewCount = item.viewCount;
    },
    async updateViewCount() {
      try {
        await this.axios.form("base:/api/admin/article/view/count", {
          id: this.updateViewCountForm.articleId,
          count: this.updateViewCountForm.viewCount,
        });
        this.$message.success("update success");
        this.updateViewCountDialogVisible = false;
      } catch (e) {
        this.$message({
          type: "error",
          message: e.message || e,
        });
      }
    },
    showUpdateLikeCountDialog(item) {
      this.updateLikeCountDialogVisible = true;
      this.updateLikeCountForm.articleId = item.id;
      this.updateLikeCountForm.likeCount = item.likeCount;
    },
    async updateLikeCount() {
      try {
        await this.axios.form("base:/api/admin/article/like/count", {
          id: this.updateLikeCountForm.articleId,
          count: this.updateLikeCountForm.likeCount,
        });
        this.$message.success("update success");
        this.updateLikeCountDialogVisible = false;
      } catch (e) {
        this.$message({
          type: "error",
          message: e.message || e,
        });
      }
    },
    push(articleId) {
      const me = this;
      this.$prompt("是否推送该文章，推送后所有app用户都会收到该消息!!!", "请确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        inputPlaceholder: "推送内容",
        inputValidator: function (value) {
          if (!value) {
            return "请输入推送内容";
          }
        },
      })
        .then(({ value }) => {
          me.axios
            .form("base:/api/admin/push/article", { articleId, alert: value })
            .then(() => {
              me.$message({
                type: "success",
                message: "推送成功!",
              });
            })
            .catch((e) => {
              me.$message({
                type: "error",
                message: e.message || e,
              });
            });
        })
        .catch(() => {
          me.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.articles {
  width: 100%;
  overflow: auto;

  .notification {
    margin: 20px;
    text-align: center;
  }

  .article:not(:last-child) {
    border-bottom: solid 1px rgba(140, 147, 157, 0.14);
  }

  .article {
    width: 100%;
    padding: 10px;
    display: flex;

    .article-right {
      width: 100%;
      margin-left: 10px;
      position: relative;

      .article-title {
        color: #555;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        text-decoration: none;
      }

      .article-meta {
        margin-top: 10px;
        display: flex;
        font-size: 12px;

        label:not(:last-child) {
          margin-right: 8px;
        }

        label {
          color: #999;
          font-size: 12px;
        }

        .article-tags {
          .el-tag + .el-tag {
            margin-left: 5px;
          }

          .button-new-tag {
            margin-left: 10px;
            height: 32px;
            line-height: 30px;
            padding-top: 0;
            padding-bottom: 0;
          }

          .input-new-tag {
            width: 90px;
            margin-left: 10px;
            vertical-align: bottom;
          }
        }
      }

      .article-info {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        min-width: max-content;

        span {
          margin-left: 10px;
          color: red;
          font-size: 13px;
          font-weight: bold;
        }
      }

      .summary {
        margin-top: 10px;
        word-break: break-all;
        -webkit-line-clamp: 2;
        overflow: hidden !important;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.5;
        margin-bottom: 10px;
      }

      .actions {
        margin-top: 10px;
        .action-item {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
